import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class Input extends Component {
  constructor(props) {
    super(props);
    this._handleOnChange = this._handleOnChange.bind(this);
    this.focus = this.focus.bind(this);
  }

  focus() {
    this.input.focus();
  }

  _handleOnChange(e) {
    const { id, onChange } = this.props;

    if(onChange) {
      onChange(id, e.target.value);
    }
  }

  render() {
    const { value, id, type, className, defaultValue, onChange, autoComplete, ...others } = this.props;
    const isControlled = value || onChange;

    return (
      <input
        className={`${className} pxl-form-control`}
        type={type}
        id={id}
        defaultValue={defaultValue}
        value={value}
        autoComplete={autoComplete}
        onChange={isControlled && this._handleOnChange}
        ref={input => {
          this.input = input;
        }}
        {...others}
      />
    );
  }
}

Input.propTypes = {
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  tabIndex: PropTypes.number,
  type: PropTypes.string,
  value: PropTypes.string,
  autoComplete: PropTypes.string
};

Input.defaultProps = {
  className: '',
  tabIndex: 0,
  type: 'text'
};

export default Input